export default "__VITE_ASSET__2d648f05__"